import {HTTP} from "../http";

export default {
    namespaced: true,

    actions: {
        submit(context, contactForm) {
            return HTTP.post('/contact', contactForm)
                .catch(err => context.commit('error/set', err.response.data, { root: true }));
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/contact.js